/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Discard_BodyInputs */

const en_us2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your current plan stays in effect. The changes in this draft are lost.`)
};

const pt_br2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano atual continua valendo. As mudanças deste rascunho se perdem.`)
};

const es_419_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan actual sigue vigente. Los cambios de este borrador se pierden.`)
};

const pt_pt2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano atual continua em vigor. As alterações deste rascunho perdem-se.`)
};

const fr_fr2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme actuel reste en vigueur. Les changements de ce brouillon sont perdus.`)
};

const de_de2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein aktueller Plan bleibt gültig. Die Änderungen in diesem Entwurf gehen verloren.`)
};

const it_it2_draft_discard_body = /** @type {(inputs: Draft_Discard_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda attuale resta valida. Le modifiche di questa bozza vanno perse.`)
};

/**
* | output |
* | --- |
* | "Your current plan stays in effect. The changes in this draft are lost." |
*
* @param {Draft_Discard_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_discard_body = /** @type {((inputs?: Draft_Discard_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Discard_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_discard_body(inputs)
	if (locale === "es-419") return es_419_draft_discard_body(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_discard_body(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_discard_body(inputs)
	if (locale === "de-DE") return de_de2_draft_discard_body(inputs)
	if (locale === "it-IT") return it_it2_draft_discard_body(inputs)
	return en_us2_draft_discard_body(inputs)
});
export { draft_discard_body as "draft.discard_body" }